import gtm from '~/services/gtm.client';
import { getPreviousPagePosition } from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  action: string;
  isBot: boolean;
  productName: string;
};

class CopOrDropEvent extends UserEvent<EventData> {
  sendToGtm() {
    gtm.pushToDataLayer({
      action: this.data.action,
      event: 'userInteraction',
      page_position: 'Cop or Drop',
      previous_page_position: getPreviousPagePosition(),
      product_name: this.data.productName
    });
  }
}

export default CopOrDropEvent;
